import helpers from '../../../../core/helpers'
import { MenuItem } from '../../__toolbarContent/displays__toolbarContent'
import translate from '../../../../core/translate'
import helpersDigitalSignages from '../../../../core/helpers/_digitalSignages'
import { cn } from 'ethcss'
import grid from '../../../../blocks.simple/grid/grid.jcss'
import item from '../../../../blocks.simple/item/item.jcss'
import { colors, text as textStyles } from '../../../../theme'
import ModalAccept from '../../../../blocks.simple/modal/_accept/modal_accept'
import styles from '../styles.jcss'
import Icon from '../../../../blocks.simple/icon/icon'
import React, { useState } from 'react'
import { SidebarMultiselectMenu } from '../../../../blocks.app/sidebarMultiselectMenu/SidebarMultiselectMenu'

export const DisplaysTopContent = ({
    p_,
    onlineSelectedItems,
    isAvailableIdentification,
    devices,
    groups,
    showWarningOnMultipleChangeSettings,
    onCloseWarning,
    onAcceptWarning,
    setShowWarningOnMultipleChangeSettings,
    isEditable,
    onGetFoldersOnMultiple,
    moveItemRef,
}: any) => {
    return (
        <div>
            <SidebarMultiselectMenu>
                <div>
                    {isEditable && (
                        <MenuItem
                            data={{ name: 'move' }}
                            onClick={() => {
                                if (moveItemRef && moveItemRef.current) {
                                    onGetFoldersOnMultiple()
                                    moveItemRef.current()
                                }
                            }}
                        />
                    )}
                    {helpers.isAvailableAction(null, {
                        key: 'digitalSignage',
                        action: 'update',
                        subaction: 'reboot',
                    }) && (
                        <MenuItem
                            data={{ name: 'reboot_device' }}
                            selectedItems={onlineSelectedItems}
                            rebootDeviceSelectedItems={p_.selectedItems}
                            afterAction={function () {
                                p_.onChange([])
                            }}
                        />
                    )}
                    {helpers.isAvailableAction(null, {
                        key: 'digitalSignage',
                        action: 'update',
                        subaction: 'restart',
                    }) && (
                        <MenuItem
                            data={{ name: 'restart_application' }}
                            selectedItems={onlineSelectedItems}
                            afterAction={function () {
                                p_.onChange([])
                            }}
                        />
                    )}
                    {helpers.isAvailableAction(null, {
                        key: 'digitalSignage',
                        action: 'update',
                        subaction: 'shutdown',
                    }) && (
                        <MenuItem
                            data={{ name: 'switchOff' }}
                            dropdown={{
                                id: 'switchOff',
                                text: translate('youAreSureSwitchOffDevices'),
                            }}
                            afterAction={function () {
                                p_.onChange([])
                            }}
                            selectedItems={onlineSelectedItems}
                        />
                    )}
                    {helpers.isEnabledPingSupport() &&
                        p_.selectedItems.some((item: { online: boolean }) => !item.online) && (
                            <MenuItem data={{ name: 'dsPingTest' }} selectedItems={p_.selectedItems} />
                        )}
                    {helpersDigitalSignages.isCheckLicenseQ() && (
                        <MenuItem data={{ name: 'setLicense' }} selectedItems={p_.selectedItems} />
                    )}
                    {helpers.isAvailableAction(null, {
                        key: 'digitalSignage',
                        action: 'update',
                        subaction: 'updateScreenshot',
                    }) && (
                        <MenuItem
                            data={{ name: 'screenshot' }}
                            selectedItems={onlineSelectedItems}
                            beforeAction={function () {
                                p_.onChange([])
                            }}
                        />
                    )}
                    {helpers.isAvailableAction(null, {
                        key: 'digitalSignage',
                        action: 'update',
                        subaction: 'changeDateTime',
                    }) && <MenuItem data={{ name: 'ds_date' }} selectedItems={p_.selectedItems} />}
                    {helpers.isAvailableAction(null, {
                        key: 'digitalSignage',
                        action: 'update',
                        subaction: 'identification_on',
                    }) &&
                        isAvailableIdentification() && (
                            <MenuItem data={{ name: 'identification_on' }} selectedItems={p_.selectedItems} />
                        )}
                    {helpers.isAvailableAction(null, {
                        key: 'digitalSignage',
                        action: 'update',
                        subaction: 'identification_off',
                    }) &&
                        isAvailableIdentification() && (
                            <MenuItem data={{ name: 'identification_off' }} selectedItems={p_.selectedItems} />
                        )}
                    {helpers.isAvailable({
                        key: 'ipTv',
                        action: 'update',
                    }) && (
                        <MenuItem
                            data={{
                                name: 'switchIpTvChannel',
                            }}
                            onClick={() => {
                                p_.openModal({
                                    modalState: 'switchIpTvChannel',
                                    modalOptions: {},
                                })
                            }}
                        />
                    )}
                    {helpers.isAvailableAction(null, {
                        key: 'digitalSignage',
                        action: 'update',
                        subaction: 'downloadDeviceInfo',
                    }) && (
                        <MenuItem
                            data={{ name: 'downloadDevices' }}
                            selectedItems={p_.selectedItems}
                            afterAction={function () {
                                const a = document.createElement('a')
                                a.href = p_.downloadLink
                                a.target = '_blank'
                                a.click()
                                a.remove()

                                p_.onChange([])
                            }}
                        />
                    )}
                    {helpers.isAvailableAction(null, {
                        key: 'digitalSignage',
                        action: 'update',
                        subaction: 'changeSettings',
                    }) && (
                        <MenuItem
                            data={{
                                name:
                                    p_.selectedItems.length && p_.selectedItems.length > 1
                                        ? 'devicesSettings'
                                        : 'generalSettings',
                            }}
                            selectedItems={devices.length ? devices : groups}
                            onClick={() => {
                                setShowWarningOnMultipleChangeSettings(true)
                            }}
                        />
                    )}
                    <MenuItem
                        data={{
                            name: 'uploadLogs',
                        }}
                        selectedItems={[...devices, ...groups]}
                    />
                </div>
            </SidebarMultiselectMenu>
            <ModalAccept
                open={showWarningOnMultipleChangeSettings}
                onReject={onCloseWarning}
                onClose={onCloseWarning}
                onAccept={onAcceptWarning}
                title={
                    <div className={styles.warningTitleWrapper}>
                        <Icon type="attention" color="darkCloud" size={24} />
                        <div className={styles.warningTitle}>{translate('attention')}!</div>
                    </div>
                }
                rejectLabel={translate('cancel')}
                acceptLabel={translate('continue')}
            >
                <div className={styles.warningDescriptionWrapper}>
                    {translate('multipleChangeSettingsDescription')}{' '}
                    <span className={styles.warningDescription}>{translate('removed')}</span>.
                </div>
            </ModalAccept>
        </div>
    )
}
